import React from 'react';
import { 
  FaPhone,
  FaMapMarkerAlt,
  FaEnvelope,
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaTiktok,
  FaTwitter,
  FaGraduationCap,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-wrapper">
        {/* Section principale */}
        <div className="footer-main">
          {/* Colonne Logo et Description */}
          <div className="footer-col logo-col">
            <div className="footer-logo">
              <FaGraduationCap className="footer-logo-icon" />
              <span className="footer-logo-text">ETEF</span>
            </div>
            <p className="footer-description">
              Un Pont vers l'excellence académique. Nous connectons les étudiants africains 
              aux opportunités éducatives en France avec un accompagnement personnalisé.
            </p>
            <div className="footer-social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaLinkedin />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaTwitter />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaYoutube />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <FaTiktok />
              </a>
            </div>
          </div>

          {/* Colonne Liens rapides */}
          <div className="footer-col">
            <h3 className="footer-section-title">Liens rapides</h3>
            <ul className="footer-links-list">
              <li>
                <a href="/" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Accueil
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Nos services
                </a>
              </li>
              <li>
                <a href="#testimonials" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Témoignages
                </a>
              </li>
              <li>
                <a href="#partners" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Partenaires
                </a>
              </li>
              <li>
                <a href="#blog" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Blog
                </a>
              </li>
              <li>
                <a href="#contact" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Colonne Services */}
          <div className="footer-col">
            <h3 className="footer-section-title">Nos services</h3>
            <ul className="footer-links-list">
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Accompagnement Visa
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Admission Universitaire
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Hébergement Étudiant
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Intégration Sociale
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Partenariats Entreprises
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link-item">
                  <FaArrowRight className="link-arrow-icon" />
                  Support Continu
                </a>
              </li>
            </ul>
          </div>

          {/* Colonne Contact */}
          <div className="footer-col contact-col">
            <h3 className="footer-section-title">Contact</h3>
            <ul className="footer-contact-list">
              <li className="contact-list-item">
                <FaPhone className="contact-item-icon" />
                <a href="tel:+33695744027" className="contact-link-item">
                  +33 6 95 74 40 27
                </a>
              </li>
              <li className="contact-list-item">
                <FaWhatsapp className="contact-item-icon" />
                <a href="https://wa.me/33695744027" target="_blank" rel="noopener noreferrer" className="contact-link-item">
                  WhatsApp
                </a>
              </li>
              <li className="contact-list-item">
                <FaMapMarkerAlt className="contact-item-icon" />
                <span className="contact-text-item">
                  Place de l'hôtel des Postes, 13001 Marseille
                </span>
              </li>
              <li className="contact-list-item">
                <FaEnvelope className="contact-item-icon" />
                <a href="mailto:contact@etef.fr" className="contact-link-item">
                  contact@etef.fr
                </a>
              </li>
            </ul>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <h4 className="newsletter-title">Newsletter</h4>
              <p className="newsletter-description">
                Recevez nos actualités et conseils
              </p>
              <form className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Votre email" 
                  className="newsletter-input-field"
                  required
                />
                <button type="submit" className="newsletter-submit-btn">
                  S'abonner
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Section bas du footer */}
        <div className="footer-bottom-section">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © ETEF {currentYear}. Tous droits réservés.
            </p>
            <div className="footer-legal-links">
              <a href="#" className="legal-link-item">Politique de confidentialité</a>
              <a href="#" className="legal-link-item">Mentions légales</a>
              <a href="#" className="legal-link-item">Conditions d'utilisation</a>
              <a href="#" className="legal-link-item">Plan du site</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;